import type { SVGProps } from 'react';

const SvgArrowNorthOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      d="M19.293 11.707a1 1 0 0 0 1.414-1.414l-8-8a1 1 0 0 0-1.414 0l-8 8a1 1 0 1 0 1.414 1.414L11 5.414V22h2V5.414z"
    />
  </svg>
);

export default SvgArrowNorthOutline;
